import { Box, FormLabel, styled } from "@mui/material";

export const Container = styled(Box)({
  position: "absolute",
  top: 5,
  left: 60,
  display: "flex",
  flexDirection: "column",
});

export const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const Label = styled(FormLabel)(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 1,
  m: 0,
  fontSize: theme.typography.caption.fontSize,
  fontWeight: 400,
}));
